<template>
  <v-card class="mt-3 pa-3" style="margin: 15px">
    <form @submit.prevent="gerarRelatorio">
      <div>
        <Select label="Ano" :options="optionsAno" v-model.number="aaletivo" :v="$v.aaletivo" :disabled="loading"/>
        <Select label="Turma" :options="optionsTurma" v-model="cdturma" :v="$v.cdturma" :disabled="loading"/>
        <Select :label="(this.aaletivo >=2020 && this.tipoDeEnsino === 'I') ? 'Campos de Experiência' : 'Disciplina'" :options="optionsDisciplina" v-model.number="cddiscipl" :v="$v.cddiscipl" :disabled="loading"/>
        <Select label="Tipo" :options="optionsTipo" v-model="tipo" :v="$v.tipo" :disabled="loading"/>
        <Select v-if="tipo === 'A'" label="Período Avaliativo" :options="optionsPeriodo" v-model="cdpravadi" :v="$v.cdpravadi" :disabled="loading"/>
        <CheckBox v-if="tipo === 'A'" label="Relatório em branco para preenchimento em sala de aula" v-model="salaAula" :disabled="loading"/>
      </div>

      <div style="text-align: right">
        <v-btn width="120px" class="rounded-sm font-weight-regular" type="submit" color="teal" style="color:white" :disabled="loading" :loading="loadingGerar">
          <v-icon size="23" left dark>picture_as_pdf</v-icon>
          Gerar
        </v-btn>
      </div>
    </form>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import registroFrequenciaAnaliticoReport from '@/reports/professor/registroFrequenciaAnaliticoReport';
import registroFrequenciaConsolidadoReport from '@/reports/professor/registroFrequenciaConsolidadoReport';
import registroFrequenciaAnaliticoSalaAulaReport from '@/reports/professor/registroFrequenciaAnaliticoSalaAulaReport';

const TurmasRepository = RepositoryFactory.get('turma');
const DisciplinaRepository = RepositoryFactory.get('disciplina');
const ProfessorReportsRepository = RepositoryFactory.get('professorReports');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const defaultSelect = () => ({
  text: '',
  value: '',
});

export default {
  name: 'DemonstrativoFrequencia',
  data() {
    return {
      aaletivo: '',
      cdturma: '',
      cddiscipl: '',
      tipo: 'A',
      tipoDeEnsino:"",
      cdpravadi: '-1',
      loading: false,
      loadingGerar: false,
      optionsTurma: [defaultSelect()],
      optionsDisciplina: [defaultSelect()],
      optionsPeriodo: [defaultSelect()],
      optionsTipo: [
        { text: 'Analítico', value: 'A' },
        { text: 'Consolidado', value: 'C' },
      ],
      salaAula: false,
    };
  },
  validations() {
    return {
      aaletivo: { required },
      cdturma: { required },
      cddiscipl: { required },
      tipo: { required },
      cdpravadi: { required: ((this.tipo === 'A')? required : '') },
    }
  },
  async created() {
    this.aaletivo = this.getAnoAtualServidor;
    await this.loadTurma();
  },
  watch: {
    async aaletivo(newVal, oldVal) {
      this.cdturma = '';
      this.cddiscipl = '';
      this.cdpravadi = '-1';
      await this.loadTurma();
    },
    async cdturma(newVal, oldVal) {
      this.cddiscipl = '';
      this.cdpravadi = '-1';
      await this.loadDisciplinaPeriodo();
    },
    async tipo(newVal, oldVal) {
      this.cdpravadi = '-1';
      this.salaAula = false;
      this.$v.cdpravadi.$reset();
    },
  },
  methods: {
    async loadTurma() {
      if(this.aaletivo === '') { return ; }
      try{
        this.loading = true;
        const { data } = await TurmasRepository.getSelectTurmasPerfil({
          ...this.userProfessor,
          ...this.school,
          aaletivo: this.aaletivo});

        this.optionsTurma = data.results.map(key => ({ text: `${key.nmturma} - ${key.horario}`, value: key.cdturma, tipoDeEnsino: key.cntpensin, }));
        this.optionsTurma.unshift(defaultSelect());
      } finally {
        this.loading = false;
      }
    },
    async loadDisciplinaPeriodo() {
      if(this.cdturma === '') { return ; }
      this.tipoDeEnsino = this.optionsTurma[this.optionsTurma.findIndex(element => element.value === this.cdturma)].tipoDeEnsino;
      try {
        this.loading = true;
        const { data } = await DisciplinaRepository.getSelectDisciplinaPerfilPeriodo({
          ...this.userProfessor,
          ...this.school,
          aaletivo: this.aaletivo,
          cdturma: this.cdturma,
        })

        this.optionsDisciplina = data.results.disciplinas.map(key => ({ text: key.dsdiscipl, value: key.cddiscipl }));
        this.optionsPeriodo = data.results.periodos.map(key => ({ text: key.dspravadi, value: key.cdpravadi }));
        this.optionsDisciplina.unshift(defaultSelect());
        this.optionsPeriodo.unshift({ value: '-1', text: 'Todos' });
      } finally {
        this.loading = false;
      }
    },
    async gerarRelatorio() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      this.loadingGerar = true;
      const dadosSubmit = {
        aaletivo: this.aaletivo,
        cdturma: this.cdturma,
        cddiscipl: this.cddiscipl,
        cdpravadi: ((this.cdpravadi === '-1') ? null : this.cdpravadi),
        ...this.userProfessor,
        ...this.school,
      };

      let filtros = {
        nmescola: this.school.nmescola,
        aaletivo: this.aaletivo,
        turma: this.optionsTurma.find(key => key.value === this.cdturma).text,
        disciplina: this.optionsDisciplina.find(key => key.value === this.cddiscipl).text,
        periodo: this.optionsPeriodo.find(key => key.value === this.cdpravadi).text,
      };

      try {
        let docDefinition = {};
        if(this.tipo === 'A') {
          if(this.salaAula) {
            const { data } = await ProfessorReportsRepository.getDemonstrativoFrequenciaAnaliticoSalaAula(dadosSubmit);

            docDefinition = await registroFrequenciaAnaliticoSalaAulaReport({
              date: data.results.date,
              time: data.results.time,
              filtros,
              data: { alunos: data.results.alunos, aulas: data.results.aulas },
              periodos: [ ...this.optionsPeriodo ],
              periodo: this.cdpravadi,
              professores: data.results.professores,
              tipoDeEnsino: this.tipoDeEnsino,
              indicaanoletivoexcedeu: data.results.configuracao_ano_letivo.indicaanoletivoexcedeu
            });
          } else {
            const { data } = await ProfessorReportsRepository.getDemonstrativoFrequenciaAnalitico(dadosSubmit);

            //data.results.alunos.forEach(aluno => console.log(`aluno: ${aluno.numatalun}`,'tamanho:', aluno.faltas.length));

            docDefinition = await registroFrequenciaAnaliticoReport({
              date: data.results.date,
              time: data.results.time,
              filtros,
              data: data.results.alunos,
              periodos: [ ...this.optionsPeriodo ],
              periodo: this.cdpravadi,
              professores: data.results.professores,
              tipoDeEnsino: this.tipoDeEnsino,
              indicaanoletivoexcedeu: data.results.configuracao_ano_letivo.indicaanoletivoexcedeu
            });

          }
        } else {
          const { data } = await ProfessorReportsRepository.getDemonstrativoFrequenciaConsolidado(dadosSubmit);

          docDefinition = await registroFrequenciaConsolidadoReport({
            date: data.results.date,
            time: data.results.time,
            filtros,
            data: data.results.alunos,
            periodos: [ ...this.optionsPeriodo ],
            professores: data.results.professores,
            tipoDeEnsino: this.tipoDeEnsino,
            indicaanoletivoexcedeu: data.results.configuracao_ano_letivo.indicaanoletivoexcedeu,
            anoSubsequente: data.results.configuracao_ano_letivo.fim.substring(0,4), // 2021
          });
        }

        //console.log('DOC', docDefinition);

        pdfMake.createPdf(docDefinition).download(docDefinition.info.title);
      } finally {
        this.loadingGerar = false;
      }
    },
  },
  computed: {
    ...mapGetters(['getAnoSistema', 'getAnoAtualServidor', 'getAnoInicioSistema', 'userProfessor', 'school', 'username']),
    optionsAno() {
      if(!this.getAnoInicioSistema || !this.getAnoAtualServidor) { return []; }
      let retornoOptions = [defaultSelect()];
      for(let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
  },
}
</script>

<style>

</style>
